import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {useTaskDescription} from './task-description-store'

export const TwEditorHistoryContainer = tw.div`
  px-0
  overflow-y-auto
`

type Props = {
  children: JSX.Element
}

export const EditorHistoryContainer = observer(({children}: Props) => {
  const [, store] = useTaskDescription()

  const noKeyboardScroll = useCallback((e: React.KeyboardEvent) => {
    if (e.code === 'PageUp' || e.code === 'PageDown') {
      e.preventDefault()
    }
  }, [])

  if (!store.taskHub?.description) {
    return <div className="h-full"></div>
  }

  const isDark = globals.theme === 'dark'
  const cls = cn('fullscreen h-full', isDark && 'dark-theme')

  return (
    <TwEditorHistoryContainer className={cls} onKeyDown={noKeyboardScroll}>
      {children}
    </TwEditorHistoryContainer>
  )
})
